"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'conversation.recording.active': 'Nagrywanie Aktywne',
    'conversation.recording.inactive': 'Nagrywanie Nieaktywne',
};
